// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
    max-width: 500px;
    margin: 50px auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
    font-family: "Arial", sans-serif;
}

.profile-container h1{
    font-size: 25px;
    font-weight: bolder;
}

.titleSeparator {
    max-width: 50%;
    border: none;
    height: 2px;
    background-color: #a7c898;
    margin-top: 15px;
}

.profile-info {
    font-size: 16px;
    color: #555;
    margin: 8px 0;
}

.loading-text {
    font-size: 18px;
    color: #888;
    font-weight: bold;
    margin-bottom: 40px;
}

.logout-btn {
    margin-top: 20px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    color: white;
    background-color: #6aaa7d;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.logout-btn:hover {
    background-color: #57986a;
}

.login-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.auth-button {
    width: 20%;
    height: 30px;
    color: #e9ecef;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    background: #000000;  /* 버튼 배경 투명 */
    cursor: pointer;
    border-radius: 10px; /* 버튼 모서리 둥글게 */
}

.auth-button:hover {
    background-color: #ffffff; /* 호버 시 배경색 변경 */
    color: #282c34; /* 호버 시 텍스트 색상 변경 */
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profile/styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB,GAAG,aAAa;IACnC,eAAe;IACf,mBAAmB,EAAE,eAAe;AACxC;;AAEA;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,cAAc,EAAE,mBAAmB;AACvC","sourcesContent":[".profile-container {\n    max-width: 500px;\n    margin: 50px auto;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    font-family: \"Arial\", sans-serif;\n}\n\n.profile-container h1{\n    font-size: 25px;\n    font-weight: bolder;\n}\n\n.titleSeparator {\n    max-width: 50%;\n    border: none;\n    height: 2px;\n    background-color: #a7c898;\n    margin-top: 15px;\n}\n\n.profile-info {\n    font-size: 16px;\n    color: #555;\n    margin: 8px 0;\n}\n\n.loading-text {\n    font-size: 18px;\n    color: #888;\n    font-weight: bold;\n    margin-bottom: 40px;\n}\n\n.logout-btn {\n    margin-top: 20px;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: bold;\n    color: white;\n    background-color: #6aaa7d;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.logout-btn:hover {\n    background-color: #57986a;\n}\n\n.login-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.auth-button {\n    width: 20%;\n    height: 30px;\n    color: #e9ecef;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    background: #000000;  /* 버튼 배경 투명 */\n    cursor: pointer;\n    border-radius: 10px; /* 버튼 모서리 둥글게 */\n}\n\n.auth-button:hover {\n    background-color: #ffffff; /* 호버 시 배경색 변경 */\n    color: #282c34; /* 호버 시 텍스트 색상 변경 */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
